import React from 'react';

function Hero() {
  const heroStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('/images/jungle.jpg')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <section id="home" className="hero" style={heroStyle}>
      <div className="hero-content">
        <h1>Phoenix Kilgore</h1>
        <p className="tagline">Turning Ideas into Reality</p>
        <div className="cta-buttons">
          <a href="#portfolio" className="cta-primary">View My Work</a>
          <a href="#contact" className="cta-secondary">Get in Touch</a>
        </div>
      </div>
    </section>
  );
}

export default Hero; 